import React, { useCallback, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import PropTypes from 'prop-types'
import SydButton from '../../../../../commonDesign/Button'
import SydModalActions from '../../../../../commonDesign/SydModal/SydModalActions'
import { useRemoveQueryBlueprint } from '../../../../../../api/denali'
import { decipherError } from '../../../../../../utils/decipherError'
import FieldDisplay from '../../../../../molecules/FieldDisplay'

const useSubmitter = (onComplete, blueprint) => {
  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(null)
  const { mutateAsync: removeQueryBlueprint } = useRemoveQueryBlueprint()

  const onSubmit = useCallback(async () => {
    const command = {
      blueprintId: blueprint.blueprintId
    }

    try {
      setError(null)
      setProcessing(true)

      const result = await removeQueryBlueprint(command)
      if (result?.statusCode === 500) {
        throw new Error('Failed to delete query blueprint')
      }
      onComplete(result)
    } catch (err) {
      setError(decipherError(err))
    } finally {
      setProcessing(false)
    }
  }, [removeQueryBlueprint, blueprint, onComplete])

  return {
    submitter: onSubmit,
    processing,
    error
  }
}

function DeleteQueryBlueprintForm ({ blueprint, onCancel, onComplete }) {
  const { submitter, processing, error } = useSubmitter(onComplete, blueprint)

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FieldDisplay
          fields={[
            { label: 'ID', value: blueprint.blueprintId },
            { label: 'Code', value: blueprint.code },
            { label: 'Name', value: blueprint.name },
            { label: 'Enabled', value: blueprint.enabled ? 'Yes' : 'No' }
          ]}
        />
        <h2>Are you sure you want to permanently delete this query blueprint?</h2>
        <p>This action cannot be undone. All associated definitions will be removed.</p>
      </Grid>

      <Grid item xs={12}>
        <SydModalActions>
          {error ? <div className='__error'>{error}</div> : null}
          <SydButton disabled={processing} variant='ghost' size='md' onClick={onCancel}>
            Cancel
          </SydButton>
          <SydButton
            processing={processing}
            variant='primary'
            priority='warning'
            icon='delete'
            size='md'
            onClick={submitter}
          >
            Delete
          </SydButton>
        </SydModalActions>
      </Grid>
    </Grid>
  )
}

DeleteQueryBlueprintForm.propTypes = {
  blueprint: PropTypes.object.isRequired,
  onComplete: PropTypes.func,
  onCancel: PropTypes.func
}

export default DeleteQueryBlueprintForm
